export default (params) => ({
  trigger: {
    name: 'product_plus.confirm_product_plus_consent',
    params: params,
  },
  config: {
    schema: {
      status: {
        enum: [
          'success',
          'failure',
          'no_delivery',
        ],
      },
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
          'free_drying',
        ],
      },
    },
    event: {
      name: 'confirm',
    },
    nonInt: false,
  },
});
